import { CachedIcon } from './CachedIcon';

/**
 * author: Google
 * id 7DFE345F-A336-43BC-89BE-18FE3C902BFC
 * name cached
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cached.svg
 * tags
 * - Arrow 
 */
export const CounterclockwiseArrowsIcon = CachedIcon;
export default CounterclockwiseArrowsIcon